import React from 'react';

export const ContactUsButton = () => {
  const handleContactUsClick = () => {
    Object.keys(window.Avochato.widgets).forEach((key) => {
      window.Avochato.widgets[key].openWithOption('current customer');
    });
  };

  return (
    <span
      style={{ cursor: 'pointer' }}
      role="button"
      tabIndex={0}
      onKeyPress={handleContactUsClick}
      onClick={handleContactUsClick}
      className="button align-self-c lg mt-10 bright-green width-100"
    >
      Contact Us
    </span>
  );
};
